export default __webpack_public_path__ + "static/media/badge.027233d1.png";